
import Attribution from '../node_modules/ol/control/Attribution.js';
import {Group as LayerGroup, Image as ImageLayer, Tile as TileLayer, Vector as VectorLayer} from '../node_modules/ol/layer';

// #if process.env.WITH_GEOTIFF
// import WebGLTileLayer from '../node_modules/ol/layer/WebGLTile'; // new ol 6.7
// #endif

import VectorTile from 'ol/layer/VectorTile';

/*
  creates default layers and optionally additional layers in olLayers list
*/

export default function(olLayers) {
  olLayers = olLayers || [];
  let mapLayers = [];

  // **** default layers
  // main mapserver WMS layer
  olLayers.push({  // for single Image or ol.layer.Tile() for tiled
    name: 'lyrBase',
    type: 'ImageWMS',
    zIndex: 4,
    visible: rwg.layers.getActiveDrawLayers('lyrBase').length > 0 ? true : false,
    source: 'mapservBase',
  })

  // single image mapserv WMS for selection hiliting (SWCO roads, TC Roads assets, TC subdivisions)
  if (rwg.config.mapservHilite) {
    olLayers.push({
      name: 'lyrQuery',
      type: 'ImageWMS',
      zIndex: 8,
      visible: false,
      source: {
        params: {
          FORMAT: 'png',
        }
      },
    })
  }

  // for vector selection hiliting and labeling
  olLayers.push({
    name: 'lyrVector',
    type: 'Vector',
    zIndex: 8,
    declutter: true,
    style: (feature, resolution) => {
      let type = feature.getGeometry().getType()
      if (type.indexOf('Polygon') > -1) {
        return rwg.styles.get('selectedParcelPolyStyle')
        // prior to 2023-01-19 this also labeled the polygon
      } else if (type === 'Point') {
        return (resolution < 100)
          ? rwg.styles.get('labelPointStyle', {text: {text: feature.get('label')}})
          : null
      }
    },
  })

  // More vector layers are add in:
  // 	 Buffer.js  'lyrBuffer'   zIndex: 6
  // 	 Draw.js    'lyrDraw'     zIndex: 9
  // 	 printx.js  'printx' for cpc printing and exporting - can't find?
  // 	 Zoom2LonLat.js 'lyrLatLonMarker' zIndex: 6
  //   GeoLocator.js  'lyrGeoLocation'  zIndex: 10
  // not using: ModifyVectorFeatures.js used to highlight the selected feature(s). Its zIndex = 10


  // **** private functions
  /*
  function imageLoadError(e) {
    let src = e.image.getImage().src;  // this fails on a tile layer
    console.error('imageloaderror', src);
    ajax('/imageLoadError.php?' + src);
  }
  */

  // for single image (non tiled) WMS
  function layerImageWMS(lyr) {
    let visible
    if (typeof lyr.visible === 'boolean') {
      visible = lyr.visible
    } else {
      visible = rwg.layers.getLayerByName(lyr.name) || false
    }
    let layer = new ImageLayer({
      title: lyr.name,
      zIndex: lyr.zIndex,
      source: typeof lyr.source === 'string' ?
              rwg.sources.get(lyr.source) :
              rwg.sources.addImageWMS(lyr.name, lyr.source),
      visible: visible
    })
    // layer.getSource().on('imageloaderror', imageLoadError);
    return layer
  }

  // Bing, TileWMS, XYZ, OSM
  function layerTile(lyr) {
    if (typeof lyr.visible !== 'boolean') {
      lyr.visible = rwg.layers.getLayerByName(lyr.name)?.state
    }
    lyr.source = typeof lyr.source === 'string' ?
      rwg.sources.get(lyr.source) :   // a string is a named of an existing source
      rwg.sources.addTile(lyr.name, lyr.type, lyr.source)  // else create a new source
    lyr.attributions = [ new Attribution(lyr.attribution) ]
    lyr.title = lyr.name
    return lyr.type === 'GeoTIFF' ? new WebGLTileLayer(lyr) : new TileLayer(lyr)
  }

  function layerVector(lyr) {
    lyr.title = lyr.name;
    // if lyr.source is a string then it's the name of an existing source
    // else create a new source w/ same name as layer's name
    lyr.source = typeof lyr.source === 'string' ?
                 rwg.sources.get(lyr.source) :
                 rwg.sources.addVector(lyr.name);
    if (typeof lyr.visible !== 'boolean') {
      lyr.visible = rwg.layers.getLayerByName(lyr.name)?.state
    }
    lyr.zIndex = lyr.zIndex || 6;
    return new VectorLayer(lyr)
  }

  function layerVectorTile(lyr) { // assumes a Mapbox Vector Tile
    lyr.title = lyr.name;
    // if lyr.source is a string then it's the name of an existing source
    // else create a new source w/ same name as layer's name
    lyr.source = typeof lyr.source === 'string' ?
                 rwg.sources.get(lyr.source) :
                 rwg.sources.addMapboxVectorTile(lyr.name, lyr.source);
    if (typeof lyr.visible !== 'boolean') {
      lyr.visible = rwg.layers.getLayerByName(lyr.name)?.state
    }
    lyr.zIndex = lyr.zIndex || 6;
    return new VectorTile(lyr)
  }

  function layerGroup(lyr) {
    let groupLayers = []
    lyr.layers.forEach(lyr => {
      groupLayers.push(make_olLayer(lyr))
    })
    return new LayerGroup({
      title: lyr.name,
      layers: groupLayers,
      visible: rwg.layers.getLayerByName(lyr.name).state,
    })
  }

  function make_olLayer(lyr) {
    let layer;
    switch (lyr.type) {
      case 'ImageWMS':  // single Image  WMS
        layer = layerImageWMS(lyr)
        break
      case 'Vector':
        layer = layerVector(lyr)
        break
      case 'VectorTile':
        layer = layerVectorTile(lyr)
        break
      case 'Group':
        layer = layerGroup(lyr) // recursively calls this func
        break
      default: // Bing, TileWMS, XYZ, OSM, GeoTIFF
        layer = layerTile(lyr)
    }
    return layer
  }

  olLayers.forEach(lyr => {
    mapLayers.push(make_olLayer(lyr))
  })

  return mapLayers;

}
